import * as React from 'react';

import sharedStyles from '../../../styles';

const AdHocInspector = ({model}) => {
  const styles = {
    ...sharedStyles.paneLayout,
    ...sharedStyles.theme,
  };

  return (
    <>
    <header css={[styles.header, styles.dark]}>
      <h1>{model.label}</h1>
    </header>
    <main css={[styles.section]}>
      {Object.entries(model.renderableProperties).map(([k, v]) => <p key={k}><strong>{k}</strong>: {v}</p>)}
    </main>
    </>
  );
};

export default AdHocInspector;
